import { FlexMiddle } from '@ubeya/shared-web/components';
import React from 'react';
import styled from 'styled-components';
import useAccount from '@ubeya/shared/hooks/account/useAccount';
import { ProfileMenu } from '../index';
import { AccountHeaderIcons } from './AccountHeaderIcons';

const IconsWrapper = styled(FlexMiddle)``;
const IconsContainer = styled.div`
  margin-right: 24px;
`;

export const MobileTopBar = () => {
  const {
    account: { isHost }
  } = useAccount();

  return (
    <IconsWrapper>
      {!isHost && (
        <IconsContainer>
          <AccountHeaderIcons isMobile />
        </IconsContainer>
      )}
      <ProfileMenu type="both" isMobile />
    </IconsWrapper>
  );
};
